<template>
  <div class="page-wrapper">
    <div class="content container-fluid">

      <div class="page-header">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="page-title">Danh mục Hạng mục Bảo dưỡng</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Dashboard</router-link></li>
              <li class="breadcrumb-item active">DM Hạng mục Bảo dưỡng</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-body d-flex flex-wrap align-items-center gap-2">
          <div class="input-group" style="max-width: 360px;">
            <input v-model.trim="searchText" type="text" class="form-control" placeholder="Tìm theo tên hạng mục..." @keyup.enter="applySearch">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" @click="applySearch" :disabled="isLoading">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>

          <div class="ml-auto d-flex align-items-center gap-2">
            <select class="form-control form-control-sm" style="width: auto" v-model.number="pageSize" @change="changeSize">
              <option :value="5">5</option>
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
            </select>
            <button class="btn btn-primary btn-sm" @click="openCreate">
              <i class="fa fa-plus"></i> Thêm Hạng mục
            </button>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body p-0">
          <div v-if="isLoading && items.length === 0" class="p-4 text-center">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 mb-0 text-muted">Đang tải danh mục...</p>
          </div>

          <div v-else-if="error && items.length === 0" class="alert alert-danger m-3">
              <i class="fa fa-exclamation-triangle mr-2"></i> {{ error }}
              <button class="btn btn-sm btn-danger ml-2" @click="fetchList">Thử lại</button>
           </div>

          <div v-else-if="items.length === 0" class="p-4 text-center text-muted">
            Không có hạng mục nào{{ q ? ' khớp với "' + q + '"' : '' }}.
          </div>

          <div v-else class="table-responsive">
            <table class="table table-hover table-striped mb-0">
              <thead class="thead-light">
                <tr>
                  <th>Tên Hạng mục</th>
                  <th style="width: 150px;">Định kỳ (Km)</th>
                  <th>Ghi chú</th>
                  <th style="width: 120px;">Trạng thái</th>
                  <th class="text-right" style="width: 100px;">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td><strong>{{ item.tenHangMuc }}</strong></td>
                  <td>{{ item.chuKyKm ? item.chuKyKm.toLocaleString('vi-VN') + ' Km' : '-' }}</td>
                  <td class="text-muted small">{{ item.ghiChu || '-' }}</td>
                  <td>
                    <span :class="['badge', item.active ? 'badge-success' : 'badge-secondary']">
                      {{ item.active ? 'Hoạt động' : 'Ngưng' }}
                    </span>
                  </td>
                  <td class="text-right">
                    <button class="btn btn-sm btn-outline-secondary mr-1" @click="openEdit(item)" title="Chỉnh sửa">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button v-if="item.active" class="btn btn-sm btn-outline-danger" @click="confirmDelete(item)" title="Xóa (Ngưng hoạt động)">
                       <i class="fa fa-trash"></i>
                    </button>
                     <button v-else class="btn btn-sm btn-outline-success" @click="restoreItem(item)" title="Khôi phục">
                       <i class="fa fa-undo"></i>
                     </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="totalPages > 1" class="p-3 d-flex justify-content-between align-items-center border-top">
            <small class="text-muted">
              Tổng: {{ totalElements }} hạng mục — Trang {{ currentPage }}/{{ totalPages }}
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a href="#" class="page-link" @click.prevent="goPage(currentPage - 1)">Trước</a>
              </li>
              <li v-for="p in totalPages" :key="p" class="page-item" :class="{ active: p === currentPage }">
                <a href="#" class="page-link" @click.prevent="goPage(p)">{{ p }}</a>
              </li>
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a href="#" class="page-link" @click.prevent="goPage(currentPage + 1)">Sau</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,.5);">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <form @submit.prevent="submitForm">
                <div class="modal-header bg-light">
                  <h5 class="modal-title font-weight-bold">
                    <i class="fa mr-2" :class="isEdit ? 'fa-pencil-alt' : 'fa-plus-circle'"></i>
                    {{ isEdit ? 'Cập nhật Hạng mục' : 'Thêm Hạng mục mới' }}
                  </h5>
                  <button type="button" class="close" @click="closeModal"><span>&times;</span></button>
                </div>

                <div class="modal-body">
                  <div v-if="formError" class="alert alert-danger py-2">{{ formError }}</div>

                  <div class="form-group">
                    <label>Tên Hạng mục <span class="text-danger">*</span></label>
                    <input v-model.trim="form.tenHangMuc" type="text" class="form-control" required autofocus maxlength="255">
                  </div>

                  <div class="form-group">
                    <label>Định kỳ theo Km (Để trống nếu không áp dụng)</label>
                    <input v-model.number="form.chuKyKm" type="number" class="form-control" min="1" placeholder="Ví dụ: 5000">
                  </div>

                  <div class="form-group">
                    <label>Ghi chú</label>
                    <textarea v-model.trim="form.ghiChu" class="form-control" rows="3" maxlength="2000"></textarea>
                  </div>

                  <div class="form-group">
                    <label>Trạng thái</label>
                    <select v-model="form.active" class="form-control">
                      <option :value="true">Đang hoạt động</option>
                      <option :value="false">Ngưng hoạt động</option>
                    </select>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-secondary" @click="closeModal">Hủy bỏ</button>
                  <button type="submit" class="btn btn-primary" :disabled="isLoading"> <span v-if="isLoading" class="spinner-border spinner-border-sm"></span>
                    <i v-else class="fa" :class="isEdit ? 'fa-save' : 'fa-plus'"></i>
                    {{ isEdit ? 'Lưu thay đổi' : 'Thêm mới' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
      </div>

      <div v-if="showDelete" class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,.5);">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Xác nhận Ngưng hoạt động</h5>
              <button type="button" class="close" @click="cancelDelete"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              Bạn có chắc chắn muốn ngưng hoạt động hạng mục <strong>{{ pendingDelete?.tenHangMuc }}</strong>?
              <p class="small text-muted mt-2">Hạng mục sẽ bị ẩn khỏi các danh sách chọn nhưng lịch sử bảo dưỡng cũ vẫn được giữ lại.</p>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-secondary" @click="cancelDelete">Huỷ</button>
              <button class="btn btn-danger" @click="doDelete" :disabled="isLoading">
                 <span v-if="isLoading" class="spinner-border spinner-border-sm"></span>
                 <i v-else class="fa fa-trash"></i> Ngưng hoạt động
              </button>
            </div>
          </div>
        </div>
      </div>

    </div> </div> </template>

<script>
import { mapState, mapActions, mapGetters } from 'pinia';
import { useDmHangMucBaoDuongStore } from '@/stores/dmHangMucBaoDuongStore'; // Import store

// Form mặc định
const DEFAULT_FORM = {
  tenHangMuc: '',
  chuKyKm: null,
  ghiChu: '',
  active: true,
};

export default {
  name: 'QuanLyHangMucBaoDuong', // Đổi tên component
  data() {
    return {
      searchText: '', // Lưu trữ text tìm kiếm
      showModal: false,
      isEdit: false,
      formError: null,
      form: { ...DEFAULT_FORM },
      showDelete: false,
      pendingDelete: null,
    };
  },
  computed: {
    // Map state từ store
    ...mapState(useDmHangMucBaoDuongStore, [
      'isLoading', // Trạng thái loading chung
      'error',     // Lỗi chung
      'items',     // Danh sách hạng mục
      'totalPages',
      'totalElements',
      'size',      // Page size
      'q',         // Query tìm kiếm từ store (đồng bộ với searchText)
      // Không cần map options ở đây nếu trang này chỉ quản lý danh mục
    ]),
    ...mapGetters(useDmHangMucBaoDuongStore, ['currentPage']),

    // v-model cho page size select
    pageSize: {
      get() { return this.size; },
      set(v) { /* handled in changeSize */ }
    }
  },
  methods: {
    // Map actions từ store
    ...mapActions(useDmHangMucBaoDuongStore, [
      'fetchList',     // Tải danh sách
      'setQuery',      // Set từ khóa tìm kiếm
      'setPage',       // Set trang
      'setSize',       // Set kích thước trang
      'createHangMuc', // Tạo mới
      'updateHangMuc', // Cập nhật
      'deleteHangMuc', // Xóa mềm (ngưng hoạt động)
    ]),

    // --- Helpers ---
    // (Có thể thêm các helper khác nếu cần)

    // --- Logic tìm kiếm, phân trang ---
    applySearch() {
        this.setQuery(this.searchText); // Cập nhật query trong store
        this.fetchList(); // Gọi action fetchList
    },
    changeSize() {
        this.setSize(Number(this.pageSize)); // Gọi action setSize
        this.fetchList(); // Gọi action fetchList
    },
    goPage(p) {
        if (p < 1 || p > this.totalPages || p === this.currentPage) return;
        this.setPage(p); // Gọi action setPage
        this.fetchList(); // Gọi action fetchList
    },

    // --- Logic Modal Thêm/Sửa ---
    openCreate() {
      this.isEdit = false;
      this.formError = null;
      this.form = { ...DEFAULT_FORM }; // Reset form
      this.showModal = true;
      document.body.style.overflow = 'hidden';
    },
    openEdit(item) {
      this.isEdit = true;
      this.formError = null;
      // Map DTO Response vào form data
      this.form = {
        tenHangMuc: item.tenHangMuc,
        chuKyKm: item.chuKyKm,
        ghiChu: item.ghiChu,
        active: item.active,
      };
      this.form._id = item.id; // Lưu ID để update
      this.showModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.showModal = false;
      document.body.style.overflow = '';
    },
    async submitForm() {
      this.formError = null;
      // Validation cơ bản
      if (!this.form.tenHangMuc || !this.form.tenHangMuc.trim()) {
        this.formError = 'Tên hạng mục là bắt buộc.'; return;
      }
       if (this.form.chuKyKm && this.form.chuKyKm <= 0) {
           this.formError = 'Định kỳ Km phải là số dương.'; return;
       }

      try {
        // Build payload (DmHangMucBaoDuongRequest)
        const payload = {
          tenHangMuc: this.form.tenHangMuc.trim(),
          chuKyKm: this.form.chuKyKm || null, // Gửi null nếu rỗng
          ghiChu: this.form.ghiChu?.trim() || null,
          active: this.form.active,
        };

        // Gọi action tương ứng
        if (this.isEdit) {
          await this.updateHangMuc(this.form._id, payload);
        } else {
          await this.createHangMuc(payload);
        }
        this.closeModal(); // Đóng modal nếu thành công
        alert(this.isEdit ? 'Cập nhật thành công!' : 'Thêm mới thành công!');
      } catch (e) {
        // Hiển thị lỗi từ store hoặc lỗi chung
        this.formError = this.error || e?.message || 'Có lỗi xảy ra.';
        console.error("Lỗi submit form hạng mục:", e);
      }
      // State loading được quản lý bởi store
    },

    // --- Logic Modal Xóa (Ngưng hoạt động) ---
    confirmDelete(item) {
      this.pendingDelete = item;
      this.showDelete = true;
      document.body.style.overflow = 'hidden';
    },
    async doDelete() {
      if (!this.pendingDelete) return;
      try {
        // Gọi action delete (thực chất là update active=false)
        await this.updateHangMuc(this.pendingDelete.id, { ...this.pendingDelete, active: false });
        // Hoặc nếu backend có API delete mềm riêng: await this.deleteHangMuc(this.pendingDelete.id);
        this.cancelDelete(); // Đóng modal
        alert('Đã ngưng hoạt động hạng mục thành công.');
      } catch (e) {
        alert(this.error || e?.message || 'Ngưng hoạt động thất bại.');
        console.error("Lỗi ngưng hoạt động:", e);
      }
    },
    // Hàm khôi phục (nếu cần)
    async restoreItem(item) {
        if (!item || item.active) return;
         if (!confirm(`Bạn muốn kích hoạt lại hạng mục "${item.tenHangMuc}"?`)) return;
         try {
             await this.updateHangMuc(item.id, { ...item, active: true });
             alert('Đã khôi phục hạng mục thành công.');
         } catch (e) {
             alert(this.error || e?.message || 'Khôi phục thất bại.');
             console.error("Lỗi khôi phục:", e);
         }
    },
     cancelDelete() {
        this.showDelete = false;
        this.pendingDelete = null;
        document.body.style.overflow = '';
    },
  },

  mounted() {
    this.searchText = this.q; // Khôi phục query search từ store (nếu có)
    this.fetchList(); // Tải danh sách khi component được mount
  }
};
</script>

<style scoped>
/* Style chung cho trang */
.page-wrapper {
  /* background-color: #f4f7f6; */
}
.container-fluid {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); /* Thêm shadow nhẹ */
}
/* Style cho bảng */
.table td,
.table th {
  vertical-align: middle;
}
.table thead th {
    background-color: #e9ecef; /* Màu nền header */
    border-bottom-width: 1px;
}
.table-hover tbody tr:hover {
    background-color: #f8f9fa;
}
/* Style cho modal */
.modal {
  overflow-y: auto;
}
body.modal-open {
    overflow: hidden !important;
    padding-right: 0 !important;
}
.modal-body {
    max-height: 70vh;
    overflow-y: auto;
}
/* Style cho badge */
.badge {
    padding: 0.4em 0.6em; /* Tăng padding */
    font-size: 0.8rem;
}
.badge.badge-success { background-color: #198754; color: #fff;}
.badge.badge-secondary { background-color: #6c757d; color: #fff;}
/* Style cho nút spinner */
.btn .spinner-border {
    width: 1em;
    height: 1em;
    vertical-align: text-bottom;
}
</style>